import api from '@/api'
// import { getDateRange } from '@/utils/dateformatter'
import moment from 'moment'
const state = {
  formParam_BillType: '',
  formParam_BizCityId: '',
  formParam_SupplyCityId: '',
  formParam_Date: [moment().subtract(3, 'month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
  formParam_Date_work: null,
  formParam_mc_po: undefined,
  formParam_mc_poi: undefined
}

const mutations = {
  setOrderId (state, id) {
    state.formParam_mc_po = id
  },
  setOrderItemId (state, id) {
    state.formParam_mc_poi = id
  },
  setDate (state, arr) {
    state.formParam_Date = arr
  },
  setDateWork (state, arr) {
    state.formParam_Date_work = arr
  },
  setBillType (state, val) {
    state.formParam_BillType = val
  },
  setBizCityId (state, val) {
    state.formParam_BizCityId = val
  },
  setSupplyCityId (state, val) {
    state.formParam_SupplyCityId = val
  }
}
const actions = {
  // 改变form param ‘采购订单ID’
  changeFormParam_orderId ({ commit }, id) {
    commit('setOrderId', id)
  },
  // 改变form param ‘采购订单行ID’
  changeFormParam_orderItemId ({ commit }, id) {
    commit('setOrderItemId', id)
  },
  // 改变form param ‘查询日期’的状态
  changeFormParam_Date ({ commit }, arr) {
    commit('setDate', arr)
  },
  changeFormParam_Date_work ({ commit }, arr) {
    commit('setDateWork', arr)
  },
  // 改变form param ‘账单类型’的状态
  changeFormParam_BillType ({ commit }, val) {
    commit('setBillType', val)
  },
  // 改变form param ‘业务城市’的状态
  changeFormParam_BizCityId ({ commit }, val) {
    commit('setBizCityId', val)
  },
  // 改变form param ‘供应商城市’的状态
  changeFormParam_SupplyCityId ({ commit }, val) {
    commit('setSupplyCityId', val)
  },
  // 账单信息列表查询
  mapListSupplierBillDataWithPage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListSupplierBillDataWithPage(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/pfcBillInfo/mapListSupplierBillDataWithPage', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/pfcBillInfo/mapListSupplierBillDataWithPage', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 供应商账单行信息查询
  mapListSupplierBillItemDataWithPage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListSupplierBillItemDataWithPage(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/pfcBillInfo/mapListSupplierBillItemDataWithPage', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/pfcBillInfo/mapListSupplierBillItemDataWithPage', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 确认金额不对
  confirmErrorSupplierBill ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.confirmErrorSupplierBill(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/pfcBillInfo/confirmErrorSupplierBill', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/pfcBillInfo/confirmErrorSupplierBill', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 确认账单
  confirmSupplierBill ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.confirmSupplierBill(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/pfcBillInfo/confirmSupplierBill', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/pfcBillInfo/confirmSupplierBill', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 获取账单类型列表
  listBillTypeData ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listBillTypeData(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/pfcBillInfo/listBillTypeData', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/pfcBillInfo/listBillTypeData', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 获取账单类型列表
  listBizCity ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listBizCity(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/pfcBillInfo/listBizCity', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/pfcBillInfo/listBizCity', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 批量确认
  confirmSupplierBillPatch ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.confirmSupplierBillPatch(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/pfcBillInfo/confirmSupplierBillPatch', error: resData.error })
          }
        }
      }).catch(e => {
        reject({ from: '/sweb/pfcBillInfo/confirmSupplierBillPatch', error: { code: 0, msg: '网络异常，请稍后再试' } })
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/bill.js